module.exports = __webpack_public_path__ + "img/20191118160608906.5ab79a1a.jpg";